export const DATA_ATTR_API  = "data-almefy-api";
export const DATA_ATTR_ID  = "data-almefy-id";
export const DATA_ATTR_KEY = "data-almefy-key";
export const DATA_ATTR_AUTH_TYPE = "data-almefy-auth-type";
export const DATA_ATTR_AUTH_IMAGE = "data-almefy-auth-image";
export const DATA_ATTR_STYLE = "data-almefy-style";
export const DATA_ATTR_AUTO_START = "data-almefy-auto-start";
export const DATA_ATTR_AUTH_URL = "data-almefy-auth-url";
export const DATA_ATTR_AUTH_HEADER = "data-almefy-auth-header";

export const STATE_HALTED = 1;
export const STATE_PROCESSING = 2;
export const STATE_RUNNING = 3;
export const STATE_SUCCESS = 4;
export const STATE_ERROR = 5;

export const MESSAGE_TYPE_DEBUG = "debug";
export const MESSAGE_TYPE_INFO = "log";
export const MESSAGE_TYPE_WARNING = "warn";
export const MESSAGE_TYPE_SUCCESS = "success";
export const MESSAGE_TYPE_ERROR = "error";
